import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Nav, Row } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useDispatch } from 'react-redux';
import { NavLink, Route, Switch } from 'react-router-dom';
import { toast } from 'react-toastify';
import logo from '../../assets/img/EPR_Recykal.svg';
import loginbg from '../../assets/img/recykul-login.png';
import { LoginContent, ResetPasswordContent, SignupContent } from '../../features/Account';
import Api from '../../shared/Config/Api';
import ApiEndpoints from '../../shared/Config/ApiEndpoints.const';
import { ChatService } from '../../shared/Services/ChatService';
import { getAccount } from '../../state/Account/accountThunks';
import './Auth.scss';
import { AuthViews } from './_authView.const';
import { useGoogleLogin } from '@react-oauth/google';
import EmailValidateContent from '../../features/Account/AuthContainer/EmailValidateContent';
import moment from 'moment';

const Auth = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [activeView, setActiveView] = useState('');
  const [authHeader, setAuthHeader] = useState('');
  const [isUserPRO, setIsUserPRO] = useState(false);
  const [emailValidated, setEmailValidated] = useState(false);
  const [authData, setAuthData] = useState({
    contactPersonEmail: '',
    contactPersonMobile: '',
    contactPersonName: '',
    hasEprAccount: true,
    addresses: [],
    name: '',
    pan: '',
    password: '',
    regType: '',
    regulatorRegNo: '',
  });

  useEffect(() => {
    ChatService().init();
  }, []);

  /**
   * ApiCall for login
   * @param data {username, password}
   */
  const doLogin = (data) => {
    setLoading(true);
    Api.post(ApiEndpoints.LOGIN, {
      email: data.username,
      password: data.password,
    }).then(
      (response) => {
        setLoading(false);
        if (response?.status === 200) {
          storeTokenAndRedirect(response.data.id_token);
        }
        return response;
      },
      () => {
        setLoading(false);
      }
    );
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      setLoading(true);
      Api.post(
        ApiEndpoints.AUTHENTICATE_GOOGLE_TOKEN + `?authorization_code=${tokenResponse?.code}`
      ).then(
        (response) => {
          if (response?.status === 200) {
            setLoading(false);
            storeTokenAndRedirect(response?.data?.id_token);
          }
          return response;
        },
        (error) => {
          setLoading(false);
          toast.error(error?.data?.message);
        }
      );
    },
    onError: () => toast.error('Unable to login, please check your credentials'),
    flow: 'auth-code',
    hosted_domain: 'recykal.com',
  });

  const validateEmail = (data) => {
    setLoading(true);
    Api.get(ApiEndpoints.USER_VALIDATION + '?email=' + data?.username).then(
      (response) => {
        if (response?.status === 200) {
          setLoading(false);
          setEmailValidated(true);
          setIsUserPRO(response?.data);
          if (response?.data === true) {
            login();
          }
        }
        return response;
      },
      (error) => {
        setLoading(false);
        toast.error(error?.data?.message);
      }
    );
  };

  /**
   * apiCall for registration
   * @param data
   */
  const doRegister = (data) => {
    setLoading(true);
    setAuthData((prevState) => {
      return { ...prevState, data: data };
    });
    const requestPayload = {
      ...data,
      addresses: data.addresses?.filter((add) => add.selected === true),
    };
    Api.post(ApiEndpoints.REGISTER, requestPayload, { timeout: 30000 }).then(
      (response) => {
        setLoading(false);
        if (response?.status === 200) {
          storeTokenAndRedirect(response.data.id_token);
        }
        return response;
      },
      () => {
        setLoading(false);
      }
    );
  };

  /**
   * store token to localStorage and redirect to home
   * @param token
   */
  function storeTokenAndRedirect(token) {
    let timeStamp = moment();
    localStorage.setItem('authenticate_token', token);
    localStorage.setItem('token_timestamp', timeStamp);
    dispatch(getAccount());
  }

  return (
    <PerfectScrollbar
      options={{ suppressScrollX: true }}
      className="AuthPage"
      style={{ height: '100vh' }}>
      <Row className="h-100">
        <Col md="6" sm="12" className="p-5 d-flex flex-column justify-content-start">
          <img height="50px" alt="company_logo" src={logo} style={{ width: 'max-content' }} />
          <div className="mt-4 w-100 h-100 d-flex justify-content-center align-items-center">
            <Card className="AuthContainer AuthPageCard border-0 h-auto">
              <Card.Header className="border-bottom-0">
                {activeView === AuthViews.SIGNUP ||
                activeView === AuthViews.RESET_PASSWORD ||
                activeView === AuthViews.RESET_PASSWORD_SUCCESS ||
                activeView === AuthViews.VALIDATE_EMAIL ||
                activeView === AuthViews.LOGIN_REGISTER ||
                activeView === '' ? (
                  <>
                    <p className="heading">
                      Meet your EPR targets
                      <br /> with ease using
                    </p>
                    <h5 className="heading">Recykal ecosystem</h5>
                  </>
                ) : (
                  authHeader
                )}
              </Card.Header>
              <Card.Body className="animated fadeIn">
                {activeView === AuthViews.SIGNUP ||
                activeView === AuthViews.VALIDATE_EMAIL ||
                activeView === '' ? (
                  <nav className="card-header-tabs nav nav-tabs">
                    <NavLink
                      className="nav-item nav-link"
                      as={Nav.Link}
                      to="/login"
                      size="sm"
                      activeClassName={'active'}>
                      Login
                    </NavLink>
                    <NavLink
                      className="nav-item nav-link"
                      as={Nav.Link}
                      to="/register"
                      size="sm"
                      activeClassName={'active'}>
                      Register
                    </NavLink>
                  </nav>
                ) : null}
                <Switch>
                  <Route path="/login">
                    {(process.env.REACT_APP_ENV === 'stage' || process.env.REACT_APP_ENV === 'development') ? (
                      <div className="mt-4">
                        <Button
                          className="btn-block mb-4"
                          variant="secondary"
                          size="lg"
                          onClick={() => login()}>
                          Continue with Google
                        </Button>
                        <div className="d-flex justify-content-center mb-3">OR</div>
                        <LoginContent loginAction={(values) => doLogin(values)} loading={loading} />
                      </div>
                    ) : (
                      <EmailValidateContent
                        loading={loading}
                        validateEmail={(values) => validateEmail(values)}
                        loginAction={(values) => doLogin(values)}
                        passActiveView={(av) => setActiveView(av)}
                        isUserPRO={isUserPRO}
                        emailValidated={emailValidated}
                        storeTokenAndRedirect={(token) => storeTokenAndRedirect(token)}
                      />
                    )}
                  </Route>
                  <Route path="/register">
                    <SignupContent
                      data={authData}
                      loading={loading}
                      passActiveView={(av) => setActiveView(av)}
                      setHeader={(header) => setAuthHeader(header)}
                      onRegister={(data) => doRegister(data)}
                    />
                  </Route>
                  <Route path="/reset-password">
                    <ResetPasswordContent
                      passActiveView={(av) => setActiveView(av)}
                      setHeader={(header) => setAuthHeader(header)}
                      loading={loading}
                    />
                  </Route>
                  <Route path="/create-password">
                    <ResetPasswordContent
                      passActiveView={(av) => setActiveView(av)}
                      setHeader={(header) => setAuthHeader(header)}
                      loading={loading}
                    />
                  </Route>
                </Switch>
              </Card.Body>
            </Card>
          </div>
        </Col>
        {!isMobile && (
          <Col md="6" className="d-block-md">
            <img className="login-bg" src={loginbg} alt="login_image" />
          </Col>
        )}
      </Row>
    </PerfectScrollbar>
  );
};

export default Auth;
